<template>
  <div>
    <template v-if="eventLookup[eventId].av_fair_theme_color">
      <!-- Multi Event / more than one theme color -->
      <span
        :style="{ backgroundColor: eventLookup[eventId].av_fair_theme_color,
        color: eventLookup[eventId].av_fair_contrast_color }"
        class="ed-itemTab ed-itemTab--fairEvent">
        {{ eventLookup[eventId].fair_title }}
      </span>
    </template>
    <template v-else>
      <!-- Single Event / only one theme color / no color found -->
      <span
        class="ed-itemTab ed-itemTab--fairEvent flag_theme__color">
        {{ eventLookup[eventId].fair_title }}
      </span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Flag',
  props: {
    eventId: Number,
    eventLookup: Object,
  },
};
</script>

<style scoped>

</style>
